import { LookupValue } from "../../../../../models/lookups/lookup.models";
import { MultipleLookupValues, MultipleLookupExclusiveAnswers } from "../multiple-lookups-control";

export abstract class MultipleLookupBaseControl {

	public selectedExclusiveId: number = null;

	protected abstract itemSource: LookupValue[];

	protected abstract values: MultipleLookupValues;

	protected abstract exclusiveAnswers: MultipleLookupExclusiveAnswers;

	protected abstract readonly: boolean;

	protected constructor (protected element: Element) {
		
	}

	public delete(id: number): void {
		this.values[id] = undefined;
	}

	protected dispatchValuesChangedEvent() {
		setTimeout(() => {   
            const valuesLoadedEvent = new CustomEvent("values-changed", { detail: { values: this.values }, bubbles: true });
            this.element.dispatchEvent(valuesLoadedEvent);
        });
	}
}
